/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { TextField, type SxProps, type Theme } from '@mui/material';

interface AutocompleteInputProps {
  params?: any;
  error?: boolean;
  placeholder?: string;
  required?: boolean;
  sx?: SxProps<Theme>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({ params, error, sx, placeholder, onChange }) => {
  return (
    <TextField
      {...params}
      sx={sx}
      onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        // Let MUI Autocomplete's inputProps.onChange manage the controlled input value.
        // The external onChange is used by callers (e.g. PeoplePicker) for search queries.
        if (onChange) {
          onChange(e);
        }
      }}
      onKeyDown={(e: { key: string; stopPropagation: () => void; preventDefault: () => void }) => {
        if (e.key === 'Enter') {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
      size="small"
      placeholder={placeholder}
      error={error}
      fullWidth
    />
  );
};

export default AutocompleteInput;
